module.exports = __webpack_public_path__ + "img/delete-red.47266a62.svg";